function AppSetting(){
    return(
        <aside className="control-sidebar control-sidebar-dark">
</aside>

    )
}

export default AppSetting;